import { ReactNode } from "react";
import { FileSchema } from "./File";

export interface VoiceBroadcastEntrySchema {
  caption: string;
  file_id: string;
  retry_count: number;
  retry_interval: number;
  numbers: {
    number: string;
    extension?: string;
  }[];
}

export interface VoiceBroadcastSchema {
  type: string;
  pbx_trunk: {
    id: number;
    caption: string;
    description: string;
  };
  id: number;
  caption: string;
  retry_count: number;
  retry_interval: number;
  file_duration: number;
  total_numbers: number;
  cost_interval_amount: number;
  cost_interval_value: number;
  estimated_duration: number;
  estimated_cost: number;
  actual_duration: number;
  actual_cost: number;
  status: BroadCastingStatusEnum;
  updated_at: string;
  created_at: string;
  pickup_loop_counter: number;
  pickup_count: number;
  send_speed: string;
}

export interface CallDetailsSchema {
  number: string;
  extension: null | string;
  user_field: null | string;
  scheduled_time: null | string;
  pickup_time: string;
  sent_time: string;
  start_time: string;
  answer_time: null | string;
  end_time: string;
  waiting_seconds: number;
  billable_seconds: number;
  duration_seconds: number;
  status: string | ReactNode;
  created_at: string;
  updated_at: string;
}
export interface VoiceBroadCastNumbersSchema {
  id: number;
  voice_broadcast_id: number;
  pbx_channel_reference_code: null;
  number: string;
  extension: null | string;
  call_input: null | string;
  total_waiting_time: null | string;
  total_talk_time: null | string;
  total_cast: null | string;
  tries: number;
  status: any;
  created_at: null | string;
  updated_at: null | string;
}

export enum BroadCastingStatusEnum {
  PENDING = "pending",
  PAYING = "paying",
  PAID = "paid",
  SENDING = "sending",
  DONE = "done",
  SENT = "sent",
  CANCELED = "canceled",
}
export enum BroadCastingSendSpeedEnum {
  NORMAL = "normal",
  FAST = "fast",
}
export enum BroadCastingNumberStatusEnum {
  CREATED = "created",
  WAITING_FOR_SEND = "waiting_for_send",
  SENDING = "sending",
  FAILED = "failed",
  ANSWERED = "answered",
  BLOCKED = "blocked",
  NO_ANSWER = "no_answer",
  BUSY = "busy",
  REJECTED = "rejected",
  UNREACHABLE = "unreachable",
  DEVICE_OFF = "device_off",
  INVALID_NUMBER = "invalid_number",
  CANCELED = "canceled",
}

export interface NumberSchema {
  number: string;
  extension: null | string;
  total_waiting_time: null | number;
  total_talk_time: null | number;
  tries: number;
  status: BroadCastingNumberStatusEnum | ReactNode;
  updated_at: string;
  created_at: string;
  id: number;
  voice_broadcast_id: number;
  pbx_channel_reference_code: null | string;
  call_input: null | string;
  total_cast: number;
}

export interface VoiceBroadcastDetailsSchema extends VoiceBroadcastSchema {
  file: FileSchema;
  user: {
    id: number;
    created_at: string;
    email: null;
    email_verified_at: null;
    mobile: string;
    mobile_verified_at: string;
    name: null | string;
    updated_at: string;
  };
}
